import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'; 
import cl from './FileModal.module.css'
import Folder from "../../../../assets/Icon/Folder";
import FileUploader from '../../../UI/FileUploader/FileUploader';
import automobyApi from '../../../../Api';
import { useAuth } from '../../../../providers/authProvider';
import { AppContext } from '../../../../providers/appProvider';

const FileModal = ({ containerService, defaultContainer, disabled }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [files, setFiles] = useState([]) 
    const {session} = useAuth(AppContext)
  
    useEffect(() => {
        setFiles(defaultContainer.files_obj.files) 
    }, [])

    const uploadFile = async (acceptedFiles) => {
         
        const formData = new FormData();

        acceptedFiles.forEach((file) => {
            formData.append('files[]', file, file.name);
        });

        formData.append('containerid', defaultContainer.id.toString());
 
        try {

            const response = await automobyApi.post("/container/file/upload", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setFiles(response.data.files)
         
            containerService.fetchList()
        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }

    const deleteFile = async (kind, file) => {
        
        const requestData = {
            container_id: defaultContainer.id, 
            file: file
        };
 
        try {
            const response = await automobyApi.post("/container/file/delete", requestData)

            setFiles(response.data.files)
  
        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }

    let mainFile;

    mainFile = <Folder/>;

    const downloadFile = () => {
        containerService.downloadDocFile(defaultContainer.id)
    } 

    return (
        <>
             
        <span className={cl.btnContainerTop} onClick={() => setIsModalOpen(true)}   >
            <span className={cl.icon  }><Folder/> </span>
            ფაილები
        </span>
   
        <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

            <div className={cl.modalHead} >
                <h3>
                    <span className={cl.iconHead} ><Folder /></span> ფაილები
                </h3>
            </div>

            <div style={{ position: 'relative', display: 'block' }}>
                <div className={ cl.threeBox }>

                    <div className={ cl.col } style={{ width: '100%' }}>
                    <span className={ cl.downBTN }onClick={() => downloadFile()}> გადმოწერა</span>

                        <FileUploader files={files}
                            uploadFile={uploadFile}
                            deleteFile={deleteFile}
                            title="ფაილები"  
                            disabled={disabled}
                            ></FileUploader>
                    </div> 
                    
                </div>
            </div>

            </Modal>


        </>
    );
};

export default FileModal;